var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 4C5.5 3.724 5.724 3.5 6 3.5C6.276 3.5 6.5 3.724 6.5 4C6.5 4.276 6.276 4.5 6 4.5C5.724 4.5 5.5 4.276 5.5 4ZM5.5 5.5C5.5 5.224 5.724 5 6 5C6.276 5 6.5 5.224 6.5 5.5V8C6.5 8.276 6.276 8.5 6 8.5C5.724 8.5 5.5 8.276 5.5 8V5.5ZM6 10C3.7945 10 2 8.2055 2 6C2 3.7945 3.7945 2 6 2C8.2055 2 10 3.7945 10 6C10 8.2055 8.2055 10 6 10ZM6 1C3.2385 1 1 3.2385 1 6C1 8.7615 3.2385 11 6 11C8.761 11 11 8.7615 11 6C11 3.2385 8.761 1 6 1Z",
    fill: "#8F9BB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoicon);
export default __webpack_public_path__ + "static/media/info icon.134eee55db3395c5b523beaf5da62681.svg";
export { ForwardRef as ReactComponent };